import React from "react";
import { styled } from "@mui/material";
import { LadderInfoIcon } from "./icons/LadderInfoIcon";
import { LadderProfilerIcon } from "./icons/LadderProfilerIcon";
import { LadderQuizIcon } from "./icons/LadderQuizIcon";
import type { Ladder } from "../types";
import { LadderGameIcon } from "./icons/ladder-game-icon.jsx";

const typeLabels: Record<string, string> = {
  quiz: "Quiz",
  inventory: "Profiler",
  instructional: "Skill Builder",
  informational: "Info",
  "knowledge-builder": "Quiz",
  "skill-builder": "Quiz",
  "profiler-values": "Profiler",
  "profiler-riasec": "Profiler",
  tracker: "Tracker",
  learn: "Learn",
  game: "Game",
};

const typeIcons: Record<string, React.ReactNode> = {
  quiz: <LadderQuizIcon />,
  inventory: <LadderProfilerIcon />,
  instructional: <LadderInfoIcon />,
  informational: <LadderInfoIcon />,
  "knowledge-builder": <LadderQuizIcon />,
  "skill-builder": <LadderQuizIcon />,
  "profiler-values": <LadderProfilerIcon />,
  "profiler-riasec": <LadderProfilerIcon />,
  tracker: <LadderInfoIcon />,
  learn: <LadderInfoIcon />,
  game: <LadderGameIcon />,
};

const LadderTypeSpan = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
  "& svg": {
    position: "relative",
    top: 3,
  },
}));

export const LadderType = ({ ladder }: { ladder: Ladder }) => (
  <LadderTypeSpan>
    {typeIcons[ladder.ladderType] || ""} {typeLabels[ladder.ladderType] || ""}
  </LadderTypeSpan>
);
